import { render, staticRenderFns } from "./Searchbar.vue?vue&type=template&id=c1496584&scoped=true&"
import script from "./Searchbar.vue?vue&type=script&lang=js&"
export * from "./Searchbar.vue?vue&type=script&lang=js&"
import style0 from "./Searchbar.vue?vue&type=style&index=0&id=c1496584&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1496584",
  null
  
)

export default component.exports